import { useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AlertDataTiles from './components/AlertsDataTiles';
import AlertAndWarnings from './components/AlertsData';

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

export default function Trips() {
  const location = useLocation();
  const navigate = useNavigate();
  const filterData = location.state?.filterData;
  // Get filters directly from URL parameters
  const urlFilters = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      group: params.get('depotName') || undefined,
      vehicle: params.get('vehicleId') || undefined,
    };
  }, [location.search]);

  const [tileData, setTilesData] = useState<ColumnObjType>();
  const [startTileDate, setStartTileDate] = useState<string>(
    new URLSearchParams(location.search).get('startDate') || '',
  );
  const [endTileDate, setEndTileDate] = useState<string>(
    new URLSearchParams(location.search).get('endDate') || '',
  );

  // Update tile dates when URL changes
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const newStartDate = params.get('startDate') || '';
    const newEndDate = params.get('endDate') || '';

    if (newStartDate && newStartDate !== startTileDate) {
      setStartTileDate(newStartDate);
    }
    if (newEndDate && newEndDate !== endTileDate) {
      setEndTileDate(newEndDate);
    }
  }, [location.search, startTileDate, endTileDate]);

  const handleTiles = (data: ColumnObjType) => {
    setTilesData(data);
  };

  return (
    <div className="flex flex-col gap-4 mt-4">
      <div className="flex-1">
        <AlertDataTiles
          filterData={filterData}
          data={tileData}
          startTileDate={startTileDate}
          endTileDate={endTileDate}
          filters={urlFilters}
        />
      </div>
      <div className="flex-1 tripTable">
        <AlertAndWarnings
          filterData={filterData}
          handleTile={handleTiles}
          setStartTileDate={setStartTileDate}
          setEndTileDate={setEndTileDate}
          filters={urlFilters}
          setFilters={() => {}}
          clearFilters={() => {}}
        />
      </div>
    </div>
  );
}
